import { getDefaultStore } from 'jotai';

import type { PermissionMode } from '@heidi/agents/contracts';
import { ensurePermissionsAtom } from '../atoms';

/**
 * `useDesktopPermissionGate().ensurePermissions` for callers that cannot run a
 * hook. Writes the same atom on the app's default store, so the mounted gate
 * host opens the same modal.
 */
export const ensureDesktopPermissions = (mode: PermissionMode): Promise<boolean> =>
  getDefaultStore().set(ensurePermissionsAtom, mode);
